import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import DeviceChangeListTable from './DeviceChange';
const DeviceChange = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Device Change' parent='Device Change'  />
      <Container fluid={true}>
        <Row>
          <DeviceChangeListTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default DeviceChange;
